// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__vLNpU","footer":"ChangeClinic_footer__a6JDD"};